// Have List SMS alert monthly caps — regional model.
//
// Twilio toll-free SMS to international destinations costs 3–10x US rates, so the cap
// depends on the user's phone region: US/Canada (phone starts with +1) gets the higher
// cap, everyone else gets the lower one. Region is determined ONLY by the phone number
// prefix — the `phoneCountryCode` field is deliberately not used (known greedy-regex bug,
// tracked separately).
//
// These constants and `getMonthlyAlertLimit` are defensive fallbacks for the UI only —
// the authoritative value is the backend-provided `alertsMonthlyLimit` field on the
// `/settings/have-list-defaults` response. They are kept byte-identical to the backend's
// own `src/constants/haveListAlerts.ts` (same file path, constant names, helper name and
// signature) so the two repos can't drift.
export const FREE_TIER_MONTHLY_ALERT_LIMIT_US = 5;
export const FREE_TIER_MONTHLY_ALERT_LIMIT_INTL = 3;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT_US = 100;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT_INTL = 25;

// Deprecated — alias to the US values. Kept one release for cross-repo parity and
// trivial reversibility; a cleanup ticket removes them once the backend drops them.
export const FREE_TIER_MONTHLY_ALERT_LIMIT = FREE_TIER_MONTHLY_ALERT_LIMIT_US;
export const ELITE_TIER_MONTHLY_ALERT_LIMIT = ELITE_TIER_MONTHLY_ALERT_LIMIT_US;

// Resolves the monthly alert cap for a user. Region is decided by the phone number:
// a `+1` prefix is US/Canada, anything else (including null/undefined) is international.
// null/undefined errs toward international — the lower cap is the cost-safe default.
export function getMonthlyAlertLimit(isElite: boolean, phoneNumber: string | null): number {
  const isUS = phoneNumber?.startsWith('+1') ?? false;
  if (isElite) {
    return isUS ? ELITE_TIER_MONTHLY_ALERT_LIMIT_US : ELITE_TIER_MONTHLY_ALERT_LIMIT_INTL;
  }
  return isUS ? FREE_TIER_MONTHLY_ALERT_LIMIT_US : FREE_TIER_MONTHLY_ALERT_LIMIT_INTL;
}
